import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 0l.898 2.764h2.906l-2.35 1.708.897 2.764L4 5.528 1.649 7.236l.898-2.764L.196 2.764h2.906L4 0z" fill="#fff" /></svg>);